import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotTrendingUp = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            fillRule="evenodd"
            d="M21.125 13c2.512.567 7.029.724 9.938 3.574 2.908 2.859 4.998 7.874 3.363 10.75-1.644 2.867-7.072 2.525-11.801 3.676-4.738 1.158-8.827 2.748-11.684 1.462-2.85-1.285-4.393-4.377-5.244-7.955-.86-3.577-.953-6.571-.118-9.075.826-2.503 2.596-4.508 4.61-5.168 2.024-.65 3.515-.09 5.311.486 1.465.626 3.105 1.675 5.625 2.25Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M38.335 10 22.5 25.833 14.168 17.5 1.668 30m36.667-20H28.334m10 0v10"
        />
    </SVG>
);
SpotTrendingUp.displayName = "SpotTrendingUp";
